import { FC, MouseEvent } from 'react';
import { PieChart } from '@mui/x-charts';
import { Typography } from '@mui/material';
import clsx from 'clsx';
import './SubTaskProgress.scss';

export interface SubTaskProgressDataItem {
  id: number;
  value: number;
  color: string;
}

export interface SubTaskProgressProps {
  data: SubTaskProgressDataItem[];
  completedCount: number;
  totalCount: number;
  onClick?: (e: MouseEvent<HTMLButtonElement>) => void;
  isExpanded?: boolean;
  size?: number;
  innerRadius?: number;
  outerRadius?: number;
  paddingAngle?: number;
  className?: string;
}

export const SubTaskProgress: FC<SubTaskProgressProps> = ({
  data,
  completedCount,
  totalCount,
  onClick,
  isExpanded = false,
  size = 14,
  innerRadius = 4.5,
  outerRadius = 7,
  paddingAngle = 0,
  className,
}) => {
  const handleClick = (e: MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    onClick?.(e);
  };

  return (
    <button
      className={clsx('sub-task-progress', className, {
        'sub-task-progress--expanded': isExpanded,
      })}
      onClick={handleClick}
    >
      <Typography variant="subtitle2" className="sub-task-progress__count">
        {completedCount}/{totalCount}
      </Typography>
      <PieChart
        series={[
          {
            data,
            innerRadius,
            outerRadius,
            paddingAngle,
          },
        ]}
        width={size}
        height={size}
        margin={{ top: 0, right: 0, bottom: 0, left: 0 }}
        slotProps={{
          legend: {
            hidden: true,
          },
        }}
        tooltip={{
          trigger: 'none',
        }}
        className="sub-task-progress__chart"
      />
    </button>
  );
};
